import React from "react";
import "./Technology.css";
import "./WorkingPlan.css";

import ReactIcon from "../Icon/react_js-removebg-preview.png";
import AWSIcon from "../Icon/img1.6ba7f8ce (1).png";
import Figma from "../Icon/img2.7a5e691b.png";
import NextIcon from "../Icon/Next_js-removebg-preview.png";
import tailwind from "../Icon/tailwind_css-removebg-preview.png";
import Nodejs from "../Icon/Nodejs.png";
import Swift from "../Icon/swift.png";
import Mogo from "../Icon/mogodb.png";
import Flutter from "../Icon/fiutter.png";
import xd from "../Icon/xd.png";

export default function Technology() {
  return (
    <div className="Technology-body">
      <div className="Technology-box">
        <div className="Technology-grid">
          <div className="Technology-grid2">
            <div className="Technology-Main-Div1">
              <div className="Technology-div2">
                <img src={Figma} alt="icon" className="Technology-Icon" />
              </div>
            </div>

            <div className="Technology-Main-Div2">
              <div className="Technology-div2">
                <img src={ReactIcon} alt="icon" className="Technology-Icon" />
              </div>
            </div>
          </div>

          <div className="Technology-Main-Div3">
            <div className="Technology-div2">
              <img src={AWSIcon} alt="icon" className="Technology-Icon" />
            </div>
          </div>

          <div className="Technology-grid3">
            <div className="Technology-Main-Div2">
              <div className="Technology-div5">
                <img src={NextIcon} alt="icon" className="Technology-Icon3" />
              </div>
            </div>

            <div className="Technology-Main-Div1">
              <div className="Technology-div2">
                <img src={tailwind} alt="icon" className="Technology-Icon2" />
              </div>
            </div>
          </div>
        </div>

        <div className="Technology-center">
          <div className="Technology-div3">
            <div className="Technology-div4">
              <p className="Technology-text">
                My <br /> Favorite <br /> Technology <br /> ...
              </p>
            </div>
          </div>
        </div>

        <div className="Technology-grid-down">
          <div className="Technology-grid2">
            <div className="Technology-Main-Div1">
              <div className="Technology-div2">
                <img src={Nodejs} alt="icon" className="Technology-Icon" />
              </div>
            </div>

            <div className="Technology-Main-Div2">
              <div className="Technology-div2">
                <img src={Swift} alt="icon" className="Technology-Icon" />
              </div>
            </div>
          </div>

          <div className="Technology-Main-Div3">
            <div className="Technology-div2">
              <img src={Mogo} alt="icon" className="Technology-Icon" />
            </div>
          </div>

          <div className="Technology-grid3">
            <div className="Technology-Main-Div2">
              <div className="Technology-div2">
                <img src={Flutter} alt="icon" className="Technology-Icon" />
              </div>
            </div>

            <div className="Technology-Main-Div1">
              <div className="Technology-div2">
                <img src={xd} alt="icon" className="Technology-Icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
